/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { CancelProposalJobResponse, CancelProposalJobVars } from '../openapi-types.gen.js';

export type { CancelProposalJobResponse, CancelProposalJobVars } from '../openapi-types.gen.js';

export const useCancelProposalJob = createMutationHook<CancelProposalJobVars, CancelProposalJobResponse, unknown>({
  specName: 'useCancelProposalJob',
  path: '/ai/proposal/jobs/{jobId}/cancel',
  method: 'POST',
  resolveUrl: (vars: CancelProposalJobVars) => `/ai/proposal/jobs/${vars.jobId}/cancel`,
  
  parseResponse: (raw: unknown): CancelProposalJobResponse => raw as CancelProposalJobResponse,
  
  
  
});
